/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 3DES加密解密
 * 
*/
import CryptoJS from "crypto-js";
/**
 * 前端本地存储密钥的两种常见方式：
 * 1. 直接硬编码在源码（不推荐，但有时用于低安全场景）
 * 2. 通过 NEXT_PUBLIC_ 环境变量注入（适合非敏感/弱加密场景）
 *
 * 注意：密钥一旦存在前端，无论哪种方式都无法做到绝对安全，只能适用于弱安全场景。
 */

//（需在打包时配置环境变量）：
export const H5_3DES_KEY = process.env.NEXT_PUBLIC_H5_3DES_KEY;


function getAesString(data: string, key1: string, iv1: any) {
  // 加密
  const key = CryptoJS.enc.Utf8.parse(key1);
  const iv = CryptoJS.enc.Utf8.parse(iv1);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // 返回的是base64格式的密文
}

function getDAesString(encrypted: string, key1: string, iv1: string) {
  // 解密
  const key = CryptoJS.enc.Utf8.parse(key1);
  const iv = CryptoJS.enc.Utf8.parse(iv1);
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * 3DES加密
 * @param str
 * @param key 
 */
export function encryptBy3DES(str: string, key = H5_3DES_KEY) {
  let encrypt = "";

  try {
    const keyHex = CryptoJS.enc.Utf8.parse(key as string);
    const encrypted = CryptoJS.TripleDES.encrypt(str, keyHex, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    encrypt = encrypted.toString();
  } catch (error) {
    console.log(error);
  }

  if (encrypt.length === 0) {
    encrypt = str;
  }
  return encrypt;
}

/**
 * 3DES解密
 * @param str
 * @param desKey 
 */
export function decryptBy3DES(str: string, desKey = H5_3DES_KEY) {
  let decrypt = "";
  try {
    if (str) {
      const key = CryptoJS.enc.Utf8.parse(desKey as string);
      const decrypted = CryptoJS.TripleDES.decrypt(str, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      decrypt = CryptoJS.enc.Utf8.stringify(decrypted).toString();
    }
  } catch (error) {
    console.log(error);
  }

  if (decrypt.length === 0) {
    decrypt = str;
  }
  return decrypt;
}

export default {
  encryptBy3DES,
  decryptBy3DES,
};
